<template>
    <div class="reverve-box app">
        <div class="main-content">
            <breadItem :title1="breadTitle1" :title2="breadTitle2" :link1="breadLink1" :link2="breadLink2"></breadItem>
            <el-form :model="ruleForm" ref="ruleForm" :rules="rules" label-width="100px" class="form-box">
                <div class="form-box-control">
                    <el-form-item label="患者姓名：" required prop="name">
                        <el-input v-model="ruleForm.name" placeholder="请输入患者姓名"></el-input>
                    </el-form-item>
                    <el-form-item label="性别：" prop="sex">
                        <el-radio-group v-model="ruleForm.sex">
                            <el-radio :label="1">男</el-radio>
                            <el-radio :label="0">女</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="预约时间：" required prop="date1" class="date-inline">
                      <el-date-picker type="date" :picker-options="effectiveTime" placeholder="请选择日期"  value-format="timestamp"  v-model="ruleForm.date1" style="width: 100%;"></el-date-picker>
                    </el-form-item>
                    <el-form-item prop="date_type" class="date-inline date-type" label="">
                        <el-radio-group v-model="ruleForm.date_type">
                            <el-radio :label="0">全天</el-radio>
                            <el-radio :label="1">上午</el-radio>
                            <el-radio :label="2">下午</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="手机号：" required prop="mobile">
                        <el-input v-model="ruleForm.mobile" placeholder="请输入手机号"></el-input>
                    </el-form-item>
                    <el-form-item label="病症选择：" required prop="illness1">
                        <el-checkbox-group v-model="ruleForm.illness1">
                            <el-checkbox v-for="item in illness" :label="item.symptom_name" :key="item.symptom_id" name="type" :title="item.symptom_name"></el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>
                    <el-form-item label="病情描述：" prop="description">
                        <el-input type="textarea" v-model="ruleForm.description" maxlength="200" show-word-limit></el-input>
                    </el-form-item>
                    <el-form-item label="期望医生：">
                        <div class="">{{ruleForm.doctor}}</div>
                    </el-form-item>
                </div>
                <el-form-item>
                    <el-button type="primary" @click="submitForm('ruleForm')" class="form-btn mr40">提交预约</el-button>
                    <el-button class="form-btn" @click="resetForm('ruleForm')">取消</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
import breadItem from '@/components/breadItem'
export default {
    data() {
      return {
        effectiveTime: {
            disabledDate: time => {
                const oneMonth = 2 * 24 * 3600 * 1000
                const mintime = Date.now() + oneMonth;
                return time.getTime() < mintime;
            }
        },
        ruleForm: {
          subhospital_id:this.$route.params.sub_hospital_id,
          hospital_id:this.$route.params.hospital_id,
          name: '',
          sex: '',
          date: '',
          date1:'',
          date_type:'',
          mobile:'',
          illness: '',
          illness1:[],
          description: '',
          doctor:this.$route.params.name,
          source:3
        },
        illness:[],
        rules: {
          name: [
            { required: true, message: '请输入患者姓名'},
          ],
          date1: [
            {  required: true, type: 'date',message: '请选择日期'}
          ],
          mobile:[
            { required: true, message: '请输入手机号码'},
          ],
          illness1:[
            { required: true, message: '病症选择不能为空'},
          ]
        },
        breadTitle1:'医生介绍',
        breadTitle2:'预约申请',
        breadLink1:'/doctors/'+this.$route.params.short_name+'.html',
        breadLink2:''
      }
    },
    components: {
        breadItem
    },
    methods: {
      submitForm(formName) {
         this.$refs[formName].validate((valid) => {
          if (valid) {
            this.ruleForm.date=this.ruleForm.date1/1000;
            this.ruleForm.illness=this.ruleForm.illness1.join(',');
            this.$axios.post(this.api.index.reservation,this.ruleForm,res =>{
                this.$message({
                    message: res.msg,
                    type: 'success'
                });   
                this.$refs[formName].resetFields();
            },err =>{
                this.$message({
                    message: err.msg,
                    type: 'error'
                });
            });
          } else {
            
            return false;
          }
        });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
      symptomList(){
        this.$axios.post(this.api.index.symptomList,{},res =>{
            this.illness=res.data.result || [];
        },err =>{
            this.illness=[];
        });
      }
    },
    watch: {
        $route(to,from){
            this.short_name=to.params.short_name;
            sessionStorage.setItem('english_short_name',this.short_name);
            this.symptomList();
        }
    },
    created(){
       this.symptomList();
    }
  }
</script>

<style scoped>
.form-box{height:726px;}
.reverve-box{color:#333;font-size:14px;}
.form-box-control{margin-bottom:40px;padding:40px 0 60px 36px;background:rgba(255,255,255,1);box-shadow:0px 0px 10px 0px rgba(0,0,0,0.1);border-radius:5px;}
</style>
<style>
.date-inline{display: inline-block;}
.reverve-box .el-form-item__label{color:#333;}
.reverve-box .el-input__inner{width:200px;height:28px;line-height:28px;border-radius:5px;border:1px solid rgba(217,217,217,1);}
.reverve-box .el-date-editor{width:200px!important;margin-right:40px;}
.reverve-box .el-textarea {width:500px;}
.reverve-box .el-textarea__inner{height:100px;resize: none!important;}
.reverve-box .el-radio{margin-right:40px;}
.reverve-box .el-radio__label{color:#666;}
.reverve-box .el-checkbox{width:314px;margin-right:0;}
.reverve-box .form-btn{width:120px;}
.reverve-box .el-checkbox__label{color:#666;width:100%;}
.date-type .el-form-item__content{margin-left:0!important;}
</style>



// WEBPACK FOOTER //
// src/view/doctors/Reserve.vue